import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private dialog: MatDialog) { }

  openCommonMatDialog(componentRef: ComponentType<any>, options: {
    className?: string,
    maxHeight?: string,
    disableClose?: boolean,
    componentData?: any,
    position?: {
      top?: string,
      left?: string,
      right?: string,
      bottom?: string,
    }
  }) {
    console.log('Opening dialog with component:', options.componentData);
    const referenceModal = this.dialog.open(componentRef, {
      panelClass: options.className,
      maxHeight: options.maxHeight,
      disableClose: options.disableClose,
      position: options.position,
      data: options.componentData
    })

    return referenceModal;
  }

  isAlreadyOpenDialog(componentRef: ComponentType<any>): boolean {
    const isAlreadyOpen = this.dialog.openDialogs.some(dialogRef => dialogRef.componentInstance instanceof componentRef);
    return isAlreadyOpen;
  }

  closeDialogIfOpen<T>(componentRef: ComponentType<T>): void {
    this.dialog.openDialogs.forEach(dialogRef => {
      if (dialogRef.componentInstance instanceof componentRef) {
        dialogRef.close();
      }
    });
  }

  closeAllDialogs(): void {
    this.dialog.closeAll();
  }

}
